import { PricingRuleSet } from "../../coverage-types";

export function getPricingRulesInLocalCurrency(
  pricingRuleSets: PricingRuleSet[],
  exchangeRate: number,
) {
  return pricingRuleSets.map((ruleSet) => {
    ruleSet.priceBrackets.map((bracket) => {
      if (ruleSet.type === "fixed") {
        bracket.value = bracket.value * exchangeRate;
      }
      bracket.pricePoint = bracket.pricePoint * exchangeRate;
      return bracket;
    });

    return ruleSet;
  });
}
